module.exports = __webpack_public_path__ + "media/application/images/svgs/linkedin-5b238434e2862c877f08572b96c0ef7b.svg";